"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zIndex = {
    pageLoader: 12,
    bottomMenu: 2,
};
exports.default = zIndex;
